import { z } from 'zod'

const optionalTrimmedString = (maxLen: number) =>
  z
    .string()
    .max(maxLen)
    .transform((value) => {
      const trimmed = value.trim()
      return trimmed === '' ? null : trimmed
    })
    .nullable()
    .optional()

export const editIndeedFlexCompanyFlowSchema = z
  .object({
    ifClientId: z.number({
      invalid_type_error: 'Indeed Flex client is required',
    }),
    canCreateShifts: z.boolean(),
    requiresSignedForm: z.boolean(),
    fileHandleId: z.number().optional(),
    shiftNotificationTitle: optionalTrimmedString(100),
    shiftNotificationMessage: optionalTrimmedString(200),
    shiftNotificationDeliveryHour: z
      .union([z.number().int().min(-48).max(4), z.nan(), z.null()])
      .optional()
      .transform((value) =>
        value == null || Number.isNaN(value) ? null : value
      ),
  })
  .superRefine((data, ctx) => {
    if (data.requiresSignedForm && data.fileHandleId == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['fileHandleId'],
        message: 'Signed form file is required',
      })
    }

    const hasTitle = data.shiftNotificationTitle != null
    const hasMessage = data.shiftNotificationMessage != null
    const hasDeliveryHour = data.shiftNotificationDeliveryHour != null
    if (
      (hasTitle || hasMessage || hasDeliveryHour) &&
      !(hasMessage && hasDeliveryHour)
    ) {
      if (!hasMessage) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['shiftNotificationMessage'],
          message: 'Message is required when configuring a notification',
        })
      }
      if (!hasDeliveryHour) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['shiftNotificationDeliveryHour'],
          message: 'Delivery hour is required when configuring a notification',
        })
      }
    }
  })

export type EditIndeedFlexCompanyFlowSchema = z.infer<
  typeof editIndeedFlexCompanyFlowSchema
>
